import { useEffect, useRef } from "react";

export function useAutoDismissMessage(message, clearMessage, delay = 5000) {
  const clearMessageRef = useRef(clearMessage);

  useEffect(() => {
    clearMessageRef.current = clearMessage;
  }, [clearMessage]);

  useEffect(() => {
    if (!message) return undefined;

    const timer = window.setTimeout(() => {
      clearMessageRef.current();
    }, delay);

    return () => window.clearTimeout(timer);
  }, [delay, message]);
}
